/*
*@/components/cat4mro/item-purchase-thread
*/
export default {
  ItemPurchaseThread: {
    form: {
      title: 'Formulario de contacto',
      validation: {
        from: 'De:',
        to: {
          title: 'Para:',
          button: 'Proveedores',
        },
        element1: {
          name: 'Nombre',
          deadline: 'Fecha Límite de Respuesta',
        },
        element2: {
          divider1: 'Información de confirmación de disponibilidad',
          stock_confirmation: '¿Solicitar Confirmación de Stock?',
          validation1: {
            quantity: 'Cantidad',
            measure_unit: 'Unidad de Medida',
          },
          validation2: {
            divider1: '¿Solicitar al proveedor disponibilidad de entrega?',
            date: 'Fecha',
            delivery_location: 'Lugar de Entrega',
          },
          checkbox: '¿Permitir al proveedor proponer nueva fecha?',
        },
        element3: {
          divider1: 'Información técnica',
          tech_specifications: '¿Solicitar especificaciones técnicas?',
          validation1: {
            placeholder: 'Especificaciones técnicas',
          },
        },
        element4: {
          tech_warranty: '¿Solicitar información de garantía y calidad?',
          validation1: {
            placeholder: 'Información de garantía y calidad',
          },
        },
        element5: {
          tech_usage: '¿Solicitar información acerca del uso?',
          validation1: {
            placeholder: 'Información acerca del uso',
          },
        },
        element6: {
          tech_manufacture: '¿Solicitar informacion de origen y fabricación?',
          validation1: {
            placeholder: 'Información de origen y fabricación',
          },
        },
        element7: {
          tech_additional_info: '¿Solicitar información adicional?',
          validation1: {
            placeholder: 'Información adicional',
          },
        },
        element8: {
          divider1: 'Adjuntar Archivo',
          validation1: {
            placeholder: 'Notas de la solicitud',
          },
        },
        send: ' Enviar',
      },
      title2: 'Proveedores',
    },
    script: {
      components: {
        uploadAttachment: {
          attachment_button: ' Agregar adjunto ',
          max_size: 'Se permite máximo 10MB',
          script: {
            handlerOnBeforeUpload: {
              isPDF: {
                title: 'Atención',
                message: 'Solo se permiten archivos pdf.',
              },
              isLt10MB: {
                title: 'Atención',
                message: 'Solo se permiten archivos de hasta 10MB.',
              },
            },
          },
        },
      },
      methods: {
        send: {
          notify: {
            title: 'Solicitud de Información',
            message: 'Solicitud de información enviada correctamente',
          },
          catch: {
            title: 'Solicitud de Información',
            message: 'Ha ocurrido un error al enviar su solicitud de información',
          },
        },
        confirmSend: {
          label1: '¿Está seguro de enviar la solicitud de información?',
          label2: 'Precaución',
          confirmButton: 'OK',
          cancelButton: 'Cancelar',
          notify: {
            title: 'Solicitud de Información',
            message: 'La solicitud de información no ha sido enviada.',
          },
          catch: {
            title: 'Solicitud de Información',
            message: 'La solicitud de información se ha cancelado',
          },
        },
        handlerOnUploadedAttachment: {
          notify: {
            title: 'Carga de archivo',
            message: 'Archivo cargado correctamente',
          },
        },
        handlerOnErrorAttachment: {
          notify: {
            title: 'Carga de archivo',
            message: 'El archivo no pudo ser cargado, intente nuevamente',
          },
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/buyer/cat4mro/components/itemPurchaseThread.js